import React from 'react';
import { Provider } from 'react-redux';
import store from '../../state';

import TeamMembershipEditTable from './TeamMembershipEditTable';

const TeamMembershipEditTableStandalone = props => (
  <Provider store={store}>
    <TeamMembershipEditTable {...props} />
  </Provider>
);

export default TeamMembershipEditTableStandalone;
